/* ------------------------------------------------------------------
   Part finder, Shopify only. V14, 7 October 2026.
   Relewise removed (Astrak no longer uses it). Before this, Relewise was
   tried first with Shopify as the fallback (V10, 2 October 2026). Now:
   - Type-ahead: Shopify /search/suggest.json (8 products).
   - Manufacturer / Model lists: assets/partfinder-models.json, the
     machine-model collections (make -> model -> collection URL).
   - Search button:
       text typed            -> /search?q=...
       one model, no text    -> that model's collection
       other selections      -> /search?q=<make model OR ...>
       nothing at all        -> the "Shop by part" category grid
   ------------------------------------------------------------------ */

const searchButton = document.querySelector(".search-button");
const resultsDiv = document.getElementById("partfinder-search-results");
const clearBtn = document.getElementById("clear-search-icon");
// const domain = window.location.origin;
// var marketPrefix = '{% if request.locale.root_url != '/' %}{{ request.locale.root_url }}{% endif %}';

//? for dropdown filter
const BRANDS = new Set();
const BRANDS_WITH_MODELS = new Map();

//? dropdown elements
const brandFilterEl = document.getElementById("brand-filter");
const modelFilterEl = document.getElementById("model-filter");

//? applied filter list
const collectionAppliedListWrapper = document.querySelector(
  ".collection-applied-filters"
);

//? query variables
const QUERY_VARIABLES = {
  brand: [],
  model: [],
};

//? ---------- Shopify fallback helpers ----------
const MODEL_URLS = new Map(); // "make|model" (normalised) -> collection URL
const normKey = (make, model) =>
  `${String(make || "").trim().toLowerCase()}|${String(model || "")
    .replace(/\s+/g, " ")
    .trim()
    .toLowerCase()}`;

//? Load make/model list from the theme
async function loadShopifyModels() {
  const root = document.querySelector("[data-partfinder-models]");
  const url = root && root.getAttribute("data-partfinder-models");
  if (!url) return;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error("HTTP " + res.status);
    const data = await res.json();
    Object.keys(data).forEach((make) => {
      BRANDS.add(make);
      if (!BRANDS_WITH_MODELS.has(make)) BRANDS_WITH_MODELS.set(make, new Set());
      const set = BRANDS_WITH_MODELS.get(make);
      (data[make] || []).forEach(([model, handle]) => {
        set.add(model);
        MODEL_URLS.set(normKey(make, model), `${getMarketPrefix()}/collections/${handle}`);
      });
    });
    renderBrandFilterOptions(Array.from(BRANDS));
    if (QUERY_VARIABLES.brand.length) renderModelFilterOptions();
  } catch (error) {
    console.warn("[Part finder] Could not load make/model list.", error);
  }
}

//? Shopify predictive search for the type-ahead
let shopifySuggestController = null;
async function fetchShopifySuggestions(query) {
  try {
    if (shopifySuggestController) shopifySuggestController.abort();
    shopifySuggestController = new AbortController();
    const root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      "/";
    const url = `${root}search/suggest.json?q=${encodeURIComponent(
      query
    )}&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last`;
    const res = await fetch(url, { signal: shopifySuggestController.signal });
    if (!res.ok) throw new Error("Shopify suggest HTTP " + res.status);
    const data = await res.json();
    if (input.value.trim() !== query) return;
    const products =
      (data &&
        data.resources &&
        data.resources.results &&
        data.resources.results.products) ||
      [];
    resultsDiv.innerHTML = "";
    if (!products.length) {
      resultsDiv.innerHTML =
        '<div class="no-products-found">No products found</div>';
      return;
    }
    products.forEach((p) => renderResultItem(p.title, p.url));
  } catch (err) {
    if (err && err.name === "AbortError") return;
    console.warn("[Part finder] Shopify suggestions failed.", err && err.message);
    resultsDiv.innerHTML = "";
  }
}

function renderResultItem(title, link) {
  const item = document.createElement("div");
  item.className = "search-result-item";
  item.innerHTML = `
      <a style="color: #000; text-decoration: none;" class="search-result-details">
        <div class="search-result-title" style="font-weight: bold;">
          <h5></h5>
        </div>
        <div class="product-direct-arrow">
          <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 22L12 12L2 2" stroke="white" stroke-width="2.25" stroke-linecap="square"/>
          </svg>
        </div>
      </a>
    `;
  item.querySelector("a").href = link;
  item.querySelector("h5").textContent = title || "Product";
  item.onclick = () => {
    window.location.href = link;
  };
  resultsDiv.appendChild(item);
}

function searchUrl(term) {
  const q = encodeURIComponent(term);
  return `${getMarketPrefix()}/search?q=${q}&type=product&options%5Bprefix%5D=last`;
}

//? get brands and models (Shopify list only)
async function getBrandsAndModels() {
  await loadShopifyModels();
}

const input = document.getElementById("partfinder-search");
let inputSearchValue;
// Search field starts
// Input typing
input.addEventListener("input", () => {
  const query = input.value.trim();
  clearBtn.style.display = query ? "flex" : "none";
  fetchedProducts(query);
  inputSearchValue = query;
  document.dispatchEvent(
    new CustomEvent("input:inUse", {
      bubbles: true,
      detail: query,
    })
  );
});

document.addEventListener("input:inUse", function (e) {});

// Clear input
clearBtn.addEventListener("click", () => {
  input.value = "";
  clearBtn.style.display = "none";
  resultsDiv.innerHTML = "";
});
// Click outside hides results
document.addEventListener("click", function (event) {
  const isClickInsideInput = input.contains(event.target);
  const isClickInsideResults = resultsDiv.contains(event.target);

  if (!isClickInsideInput && !isClickInsideResults) {
    resultsDiv.innerHTML = "";
  }
});

// Redirect to search page
function redirectToSearchPage() {
  const query = input.value.trim();
  if (query) {
    window.location.href = searchUrl(query);
  } else {
    window.location.href = "/search";
  }
}
// Enter key triggers search
input.addEventListener("keydown", (e) => {
  if (e.key === "Enter") {
    e.preventDefault();
    redirectToSearchPage();
  }
});

let suggestDebounce = null;
function fetchedProducts(query) {
  clearTimeout(suggestDebounce);
  if (!query || query.length < 2) {
    if (shopifySuggestController) shopifySuggestController.abort();
    resultsDiv.innerHTML = "";
    return;
  }
  suggestDebounce = setTimeout(() => fetchShopifySuggestions(query), 150);
}

// Market prefix from URL
function getMarketPrefix() {
  const pathSegments = window.location.pathname.split("/").filter(Boolean);
  const firstSegment = pathSegments[0] || "";
  const marketPattern = /^[a-z]{2}(-[a-z]{2})?$/i;
  return marketPattern.test(firstSegment) ? `/${firstSegment}` : "";
}

// Search field ends

//? render brand filter options
function renderBrandFilterOptions(options) {
  //? guard clause
  if (!brandFilterEl) {
    console.error("brandFilter element not found");
    return;
  }

  //? dropdown element list
  const dropdownListEl = brandFilterEl.querySelector(
    ".dropdown-filter__options-list"
  );

  if (!dropdownListEl) {
    console.error("brand dropdownList element not found ");
    return;
  }
  //? clear options
  dropdownListEl.innerHTML = "";

  if (options.length === 0) {
    brandFilterEl.classList.add("disabled");
    return;
  }

  options.sort().forEach((value) => {
    const html = `<li data-filter-input=${value} role="option" class="dropdown-filter__option dropdown-filter__option--checkbox">
      <label class="dropdown-filter__option-label" for="${String(
        value || ""
      ).replaceAll(" ", "-")}">
        <input
          type="checkbox"
          class="dropdown-filter__option-checkbox"
          name="brand"
          data-filter-input='${value}'
           ${QUERY_VARIABLES.brand.includes(value) ? `checked=${true}` : ""}
          value="${value}"
          id="${String(value || "").replaceAll(" ", "-")}" />
        <span class="dropdown-filter__option-check-mark-icon"></span>
        ${value}
      </label>
    </li>`;
    dropdownListEl.insertAdjacentHTML("beforeend", html);
  });
}

//? render model filter options
function renderModelFilterOptions() {
  if (!modelFilterEl) {
    console.error("modelFilterEl not found");
    return;
  }

  const modelFilterOptionsList = modelFilterEl.querySelector(
    ".dropdown-filter__options-list"
  );

  if (!modelFilterOptionsList) {
    console.error("modelFilterOptionsList not found");
    return;
  }

  //? Clear options
  modelFilterOptionsList.innerHTML = "";

  //? guard clause
  if (QUERY_VARIABLES.brand.length === 0) {
    modelFilterEl.classList.add("disabled");
    modelFilterEl
      .querySelector(".dropdown-filter__trigger")
      .classList.remove("active");
    modelFilterEl
      .querySelector(".dropdown-filter__options")
      .classList.remove("open");
    modelFilterEl.setAttribute("aria-disabled", "true");
    return;
  }
  //? Check if any brand is selected and has models
  let hasModels = false;
  QUERY_VARIABLES.brand.forEach((brand) => {
    if (!BRANDS_WITH_MODELS.has(brand)) return;
    hasModels = true;
    Array.from(BRANDS_WITH_MODELS.get(brand)).forEach((model) => {
      const html = `<li role="option" data-filter-input='${model}' class="dropdown-filter__option dropdown-filter__option--checkbox">
        <label class="dropdown-filter__option-label" for="${String(
          model || ""
        ).replaceAll(" ", "-")}">
          <input
            type="checkbox"
            class="dropdown-filter__option-checkbox"
            name="model"
            data-filter-input='${model}'
             ${QUERY_VARIABLES.model.includes(model) ? `checked=${true}` : ""}
            value="${model}"
            id="${String(model || "").replaceAll(" ", "-")}" />
          <span class="dropdown-filter__option-check-mark-icon"></span>
          ${model}
        </label>
      </li>`;
      modelFilterOptionsList.insertAdjacentHTML("beforeend", html);
    });
  });

  //? Enable/disable the model filter based on whether there are models to show
  const shouldEnableModelFilter = hasModels;
  if (shouldEnableModelFilter) {
    modelFilterEl.classList.remove("disabled");
    modelFilterEl.setAttribute("aria-disabled", "false");
  } else {
    modelFilterEl.classList.add("disabled");
    modelFilterEl
      .querySelector(".dropdown-filter__trigger")
      .classList.remove("active");
    modelFilterEl
      .querySelector(".dropdown-filter__options")
      .classList.remove("open");
    modelFilterEl.setAttribute("aria-disabled", "true");
  }
}

//? render applied filters list
function renderAppliedFiltersList() {
  if (!collectionAppliedListWrapper) {
    console.error("Collection applied list wrapper not found");
    return;
  }
  const appliedFiltersList = collectionAppliedListWrapper.querySelector(
    ".collection-applied-filters-list"
  );
  if (!appliedFiltersList) {
    console.error("Applied filters list not found");
    return;
  }

  //? clear list
  appliedFiltersList.innerHTML = "";

  const manufacturerFilterInputs = QUERY_VARIABLES.brand || [];
  const modelFilterInputs = QUERY_VARIABLES.model || [];
  const filtersList = [
    ...manufacturerFilterInputs.map((brand) => ({
      key: brand,
      value: brand,
      id: "brand",
      filterName: "Manufacturer",
    })),
  ];

  if (manufacturerFilterInputs.length > 0) {
    manufacturerFilterInputs.forEach((brand) => {
      if (!BRANDS_WITH_MODELS.has(brand)) return;
      const models = BRANDS_WITH_MODELS.get(brand);
      modelFilterInputs.forEach((model) => {
        if (models.has(model)) {
          filtersList.push({
            key: model,
            value: `${brand} ${model}`,
            id: "model",
            filterName: "Model",
          });
        }
      });
    });
  }

  //? if filter list length is greater than 0
  if (filtersList.length > 0) {
    //? remove hidden class
    collectionAppliedListWrapper.classList.remove("hidden");

    //? clear icon svg
    const clearIconSvg = `<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="16" height="16" rx="8" fill="black"/>
        <g clip-path="url(#clip0_7651_4207)">
        <path d="M11 5L5 11" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        <path d="M5 5L11 11" stroke="white" stroke-width="1.5" stroke-linecap="square" stroke-linejoin="round"/>
        </g>
        <defs>
        <clipPath id="clip0_7651_4207">
        <rect width="8" height="8" fill="white" transform="translate(4 4)"/>
        </clipPath>
        </defs>
        </svg>`;

    //? loop it
    filtersList.forEach((filter) => {
      const html = `<li>
        <span class="applied-filter-label">${filter.value}</span>
        <span class="applied-filter-clear-icon" data-filter-input='${filter.key}' data-type="${filter.key}" data-id="${filter.id}" data-name="${filter.filterName}" data-value="${filter.value}">
        ${clearIconSvg}
      </span></li>`;
      appliedFiltersList.insertAdjacentHTML("beforeend", html);
    });
  } else {
    //? add hidden class
    collectionAppliedListWrapper.classList.add("hidden");
  }
}

//? open dropdown filter
function openDropdownFilter(e) {
  const triggerEl = e.target.closest(".dropdown-filter__trigger");
  const optionsEl = triggerEl.nextElementSibling;
  if (triggerEl && optionsEl) {
    if (!triggerEl.classList.contains("active")) {
      //? before all opened dropdowns
      closeDropdownFilters();
      optionsEl.classList.add("open");
      triggerEl.classList.add("active");
    } else {
      optionsEl.classList.remove("open");
      triggerEl.classList.remove("active");
    }
  }
}

//? close all dropdown filters
function closeDropdownFilters() {
  const dropdownFilters = document.querySelectorAll(".dropdown-filter");
  dropdownFilters.forEach((dropdownFilter) => {
    const triggerEl = dropdownFilter.querySelector(".dropdown-filter__trigger");
    const optionsEl = dropdownFilter.querySelector(".dropdown-filter__options");
    if (triggerEl && optionsEl) {
      optionsEl.classList.remove("open");
      triggerEl.classList.remove("active");
    }
  });
}

//? filter by brand and model
function filterByBrandAndModel(e) {
  const checkboxEl = e.target;
  const { name: filterName, checked, value: checkboxValue } = checkboxEl;
  //? Get current filter values
  const productBrands = new Set(QUERY_VARIABLES.brand);
  const productModels = new Set(QUERY_VARIABLES.model);

  //? Update checked filters and query variables
  if (checked) {
    if (filterName === "brand") productBrands.add(checkboxValue);
    else productModels.add(checkboxValue);
  } else {
    if (filterName === "brand") productBrands.delete(checkboxValue);
    else productModels.delete(checkboxValue);
  }
  //? brand filter specific logic
  if (filterName === "brand") {
    //? If last brand is deselected, clear all models and update accordingly
    if (!checked && productBrands.size === 0) {
      //? remove all filters
      productModels.clear();
      QUERY_VARIABLES.brand = [];
      QUERY_VARIABLES.model = [];

      //? filter label update
      updateFilterLabel("brand", "Manufacturer", true);
      updateFilterLabel("model", "Model", true);

      //? update state
      updateState();

      return;
    }
    //? suppose manufacturer deselected but model is active then remove active model beyond to manufacturer
    //? cleaned over
    if (!checked && BRANDS_WITH_MODELS.has(checkboxValue)) {
      Array.from(BRANDS_WITH_MODELS.get(checkboxValue)).forEach((model) => {
        if (productModels.has(model)) {
          productModels.delete(model);
        }
      });

      QUERY_VARIABLES.model = [...productModels];
      QUERY_VARIABLES.brand = [...productBrands];

      //? filter label update
      updateFilterLabel("model", "Model", false);
      updateFilterLabel("brand", "Manufacturer", false);

      //? update state
      updateState();

      return;
    }
  }

  //? update query variables
  QUERY_VARIABLES.brand = [...productBrands];
  QUERY_VARIABLES.model = [...productModels];

  //? update filter label
  updateFilterLabel(
    filterName,
    filterName === "brand" ? "Manufacturer" : "Model"
  );
  //? update state
  updateState();
}

//? update filter labels
function updateFilterLabel(key, defaultLabel, reset = false) {
  //? reset
  if (reset) {
    document
      .querySelector(`#${key}-filter`)
      .querySelector(".dropdown-filter__label").textContent = defaultLabel;
    return;
  }

  //? update
  document
    .querySelector(`#${key}-filter`)
    .querySelector(".dropdown-filter__label").textContent =
    QUERY_VARIABLES[key].length <= 0
      ? `${defaultLabel}`
      : QUERY_VARIABLES[key].length > 2
      ? QUERY_VARIABLES[key].slice(0, 2).join(", ") + ` ${"..."}`
      : QUERY_VARIABLES[key].join(", ");
}

//? update state
function updateState() {
  //? render model filter options
  renderModelFilterOptions();

  //? render collection applied list
  renderAppliedFiltersList();

  //? render brand filter options
  renderBrandFilterOptions(Array.from(BRANDS));
  document.dispatchEvent(
    new CustomEvent("filter:brand", {
      bubbles: true,
      detail: { productMetafield: QUERY_VARIABLES },
    })
  );
}

// Search button functionality
function handleSearchClick() {
  const marketCode = getMarketPrefix();
  const queryString = Object.entries(QUERY_VARIABLES)
    .map(([key, values]) =>
      values.map((value) => `${key}=${encodeURIComponent(value)}`).join("&")
    )
    .filter(Boolean)
    .join("&");
  const searchValue = (input.value || inputSearchValue || "").trim();
  const brands = QUERY_VARIABLES.brand;
  const models = QUERY_VARIABLES.model;
  let finalUrl;

  if (searchValue) {
    //? Text typed: Shopify search
    finalUrl = `${searchUrl(searchValue)}${queryString ? `&${queryString}` : ""}`;
  } else if (models.length === 1 && brands.length) {
    //? One machine picked: go straight to its model collection when there is one
    const make = brands.find((b) =>
      BRANDS_WITH_MODELS.has(b) && BRANDS_WITH_MODELS.get(b).has(models[0])
    ) || brands[0];
    finalUrl =
      MODEL_URLS.get(normKey(make, models[0])) || searchUrl(`${make} ${models[0]}`);
  } else if (models.length > 1) {
    const terms = models.map((m) => {
      const make = brands.find((b) => BRANDS_WITH_MODELS.has(b) && BRANDS_WITH_MODELS.get(b).has(m)) || "";
      return `${make} ${m}`.trim();
    });
    finalUrl = searchUrl(terms.join(" OR "));
  } else if (brands.length) {
    finalUrl = searchUrl(brands.join(" OR "));
  } else {
    //? Nothing chosen: show the categories
    const grid = document.getElementById("shop-by-part");
    if (grid) {
      grid.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }
    finalUrl = `${marketCode}/#shop-by-part`;
  }
  window.location.href = finalUrl;
}
searchButton.addEventListener("click", handleSearchClick);

//? clear applied filter
function clearAppliedFilterByIcon(e) {
  const spanEl = e.target.closest(".applied-filter-clear-icon");
  const filterInput = spanEl.getAttribute("data-filter-input");
  const filterId = spanEl.getAttribute("data-id");
  const filterName = spanEl.getAttribute("data-name");

  if (filterInput && filterId && filterName) {
    //? if filter id brand or model then update query variables
    if (filterId === "brand") {
      QUERY_VARIABLES.brand = QUERY_VARIABLES.brand.filter(
        (brand) => brand !== filterInput
      );

      //? remove models associated with brand
      if (BRANDS_WITH_MODELS.has(filterInput)) {
        Array.from(BRANDS_WITH_MODELS.get(filterInput)).forEach((model) => {
          if (QUERY_VARIABLES.model.includes(model)) {
            QUERY_VARIABLES.model = QUERY_VARIABLES.model.filter(
              (m) => m !== model
            );
          }
        });

        //? update label
        updateFilterLabel("model", "Model", QUERY_VARIABLES.model.length === 0);
      }
    } else if (filterId === "model") {
      QUERY_VARIABLES.model = QUERY_VARIABLES.model.filter(
        (model) => model !== filterInput
      );
    }

    //? update label
    updateFilterLabel(filterId, filterName, false);

    //? update state
    updateState();
  }
}

//? initial load
document.addEventListener("DOMContentLoaded", getBrandsAndModels);

//? events
//? click
document.addEventListener("click", function (e) {
  //? open dropdown filter
  if (e.target.closest(".dropdown-filter__trigger")) {
    openDropdownFilter(e);
    return;
  } //? clear applied filter
  else if (e.target.closest(".applied-filter-clear-icon")) {
    clearAppliedFilterByIcon(e);
    return;
  } else if (!e.target.closest(".dropdown-filter")) {
    closeDropdownFilters();
    return;
  }
});

//? change
document.addEventListener("change", function (e) {
  if (
    e.target.closest(
      ".dropdown-filter__option.dropdown-filter__option--checkbox"
    )
  ) {
    filterByBrandAndModel(e);
    return;
  }
});
